/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { HistoryReceiptionTypeTitles } from "../../HistoryUIHelpers";

export const ReceiverNameColumnFormatter = (cellContent, row, rowIndex) => {
  const { receiver } = row;
  const { firstname = "", lastname = "", account_number = "" } = receiver || {};
  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {`${firstname} ${lastname}`}
        {firstname.length === 0 && lastname.length === 0 && "-"}
        <br />
        {account_number === null ? "" : `- ${account_number}`}
      </div>
      <> </>
    </>
  );
};
